import { useFeature } from "byzantine";
import { RecipientDrawer, DRAWER_TYPES } from "../../../RecipientDrawer";
import { RecipientDrawer as NewRecipientDrawer } from "../../../../src/modules/recipientDrawer";

interface InternationalWireRecipientDrawerProps {
  isOpen: boolean;
  recipientId?: API.RecipientId;
  onClose: (recipientId?: API.RecipientId) => void;
}

const InternationalWireRecipientDrawer = ({
  isOpen,
  recipientId,
  onClose,
}: InternationalWireRecipientDrawerProps) => {
  const isNewDrawerEnabled = useFeature().featureEnabled("recipient_drawer");

  if (isNewDrawerEnabled) {
    return (
      <NewRecipientDrawer
        isOpen={isOpen}
        flow="internationalWire"
        onClose={({ recipient }) => onClose(recipient?.id)}
        {...(recipientId ? { mode: "edit", recipientId } : { mode: "create" })}
      />
    );
  }

  return (
    <RecipientDrawer
      handleClose={onClose}
      isOpen={isOpen}
      fromACHFlow={false}
      fromInternationalWireFlow={true}
      drawerType={recipientId ? DRAWER_TYPES.edit : DRAWER_TYPES.add}
      recipientId={recipientId}
    />
  );
};

export default InternationalWireRecipientDrawer;
